import { useMutation } from 'react-query';
import { updateListOwnership } from '../services/api/UpdateListOwnership';

export const useTransferWatchlist = () => {
  const mutation = useMutation(updateListOwnership);

  const onSubmit = (idList: number, newOwnerIdUser: number) =>
    mutation.mutateAsync({
      id_list: idList,
      new_owner_id_user: newOwnerIdUser,
    });

  return {
    onSubmit,
    isLoading: mutation.isLoading,
  };
};
